import { useEffect } from 'react';

import { apiRequest } from '@/src/services';

export default function ImpersonateRedirect() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const userId = params.get('userId');

        if (!userId) {
            window.location.href = '/user/dashboard';
            return;
        }

        async function run() {
            try {
                await apiRequest('post', `dbo/users/${userId}/impersonate`);
            } catch (err) {
                console.error(err);
                alert('Failed to impersonate user');
            } finally {
                window.location.href = '/user/dashboard';
            }
        }

        run();
    }, []);

    return <div style={{ padding: 20 }}>Impersonating…</div>;
}
